import React from "react";
import { Box, Button, Stack } from "@mui/material";
import useQuestionSectionStyles from "../testStyle/iitStyle/questionSectionStyle";

function ControlButtons({
  handleSaveNext,
  handleMarkReview,
  handleClearResponse,
  handleSubmit,
  currentQuestion,
  questionData,
  handleBack,
  handleNext,
}) {
  const classes = useQuestionSectionStyles();
  return (
    <div className={classes.navButtons}>
      <Stack spacing={1}>
        <Box className={classes.buttonGroup} direction="row">
          <Button
            sx={{
              whiteSpace: { xs: "normal", sm: "nowrap" },
              background: "#5cb85c",
              borderRadius: "0px",
              "@media (min-width: 800px) and (max-width: 898px)": {
                fontSize: "0.7rem",
                padding: "6px 12px",
              },
            }}
            variant="contained"
            onClick={() => handleSaveNext()}
          >
            SAVE & NEXT
          </Button>
          <Button
            sx={{
              whiteSpace: { xs: "normal", sm: "nowrap" },
              background: "#f0ad4e",
              borderRadius: "0px",
              "@media (min-width: 800px) and (max-width: 898px)": {
                fontSize: "0.7rem",
                padding: "6px 12px",
              },
            }}
            variant="contained"
            onClick={() => handleMarkReview("marked", true)}
          >
            SAVE & MARK FOR REVIEW
          </Button>
          <Button
            sx={{
              whiteSpace: { xs: "normal", sm: "nowrap" },
              color: "black",
              borderColor: "black",
              borderRadius: "0px",
              "@media (min-width: 800px) and (max-width: 898px)": {
                fontSize: "0.7rem",
                padding: "6px 12px",
              },
            }}
            variant="outlined"
            onClick={handleClearResponse}
          >
            CLEAR RESPONSE
          </Button>
          <Button
            sx={{
              whiteSpace: { xs: "normal", sm: "nowrap" },
              background: "#337ab7",
              borderRadius: "0px",
              "@media (min-width: 800px) and (max-width: 898px)": {
                fontSize: "0.7rem",
                padding: "6px 12px",
              },
            }}
            variant="contained"
            onClick={() => handleMarkReview("marked", false,true)}
          >
            MARK FOR REVIEW & NEXT
          </Button>
        </Box>

        <Box className={classes.buttonGroup} direction="row">
          <Box sx={{ 
            display: { xs: "none", sm: "block" }, 
            color: "black",
            "@media (min-width: 800px) and (max-width: 898px)": {
              "& button": {
                fontSize: "0.7rem",
                padding: "6px 12px",
              },
            },
          }}>
            <Button
              variant="outlined"
              onClick={handleBack}
              disabled={currentQuestion === 0}
              sx={{ 
                color: "black", 
                borderColor: "black", 
                borderRadius: "0px",
              }}
            >
              &lt;&lt; Back
            </Button>
            <Button
              variant="outlined"
              onClick={handleNext}
              disabled={currentQuestion === questionData?.length - 1}
              sx={{ 
                color: "black", 
                borderColor: "black", 
                borderRadius: "0px",
              }}
            >
              Next &gt;&gt;
            </Button>
          </Box>
          <Button
            variant="contained"
            sx={{
              background: "#5cb85c",
              borderRadius: "0px",
              "@media (min-width: 800px) and (max-width: 898px)": {
                fontSize: "0.7rem",
                padding: "6px 12px",
              },
            }}
            onClick={handleSubmit}
          >
            SUBMIT
          </Button>
        </Box>
      </Stack>
    </div>
  );
}

export default ControlButtons;